import { Drawer, Grid, Radio } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useState, useEffect } from "react";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import { getSteelConsumption, getSteelConsumptionById } from "../../redux/reducers/pilesReducers";
import { getSteelReconciliation, getSteelReconciliationByProject, setInitSteelReconciliationDataById } from "../../redux/reducers/inventorySlice";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import SteelReconciliationBar from "./SteelReconciliationBar";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import "./Reports.scss";
import Slider from "../Machine/Slider";
import SteelCard from "./SteelCard";
import PileDrawer from "./PileDrawer";
import List from "../../utilities/List";
const steelDias = [
    "8 mm",
    "10 mm",
    "12 mm",
    "16 mm",
    "20 mm",
    "25 mm",
    "32 mm",
    "36 mm",
  ];

const SteelReconciliationReport = () => {

    const dispatch = useDispatch<AppDispatch>();
    const allProjectData = useSelector(
        (state: any) => state.PROJECT.allProjectData
    );

    //--to get current details
    useEffect(() => {
        dispatch(setInitSteelReconciliationDataById());

    }, [dispatch]);
    const steelConsumptionData = useSelector((state: any) => state.PILES.steelConsumption);
    const steelConsumptionDataProjectwise = useSelector((state: any) => state.PILES.steelConsumptionById);
    const steelReconciliationData = useSelector((state: any) => state.INVENTORY.steelReconciliationData);
    const steelReconciliationDataById = useSelector((state: any) => state.INVENTORY.steelReconciliationDataByProject);
    const [cardData, setCardData] = useState([]);
    const [cardData2, setCardData2] = useState([]);
    const [projectId, setProjectId] = useState("");
    const [projectName, setProjectName] = useState("");
    const [pileId, setPileId] = useState("");
    const [pileList, setPileList] = useState([]);
    const [value, setValue] = useState({ from: "", to: "" });
    const [isOverallTable, setIsOverallTable] = useState(true);
    const [drawerToggle, setDrawerToggle] = useState(false);
    const [drawerData, setDrawerData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [search, setSearch] = useState("");

    const handleFilterDate = () => {
        setCardData([]);
        setTableData([]);
      if (value.to && value.from) {
        if (projectId === "") {
          dispatch(
            getSteelConsumption({
              endPoint: `piles/steel-consumption?to=${value.to}&from=${value.from}`,
            })
          );
          dispatch(
            getSteelReconciliation({
              endPoint: `inventory/get-overall-steel-reconciliation?to=${value.to}&from=${value.from}`,
            })
          );
        } else {
          dispatch(
            getSteelConsumptionById({
              endPoint: `piles/steel-consumption/?projectId=${projectId}&to=${value.to}&from=${value.from}`,
            })
          );
          dispatch(
            getSteelReconciliationByProject({
              endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId}&to=${value.to}&from=${value.from}`,
            })
          );
        }
      }
    };
    const resetToAll = () => {
      setValue({ from: "", to: "" });
      if (projectId === "") {
        dispatch(
          getSteelConsumption({
            endPoint: `piles/steel-consumption`,
          })
        );
        dispatch(
          getSteelReconciliation({
            endPoint: `inventory/get-overall-steel-reconciliation`,
          })
        );
      } else {
        dispatch(
          getSteelConsumptionById({
            endPoint: `piles/steel-consumption/?projectId=${projectId}`,
          })
        );
        dispatch(
          getSteelReconciliationByProject({
            endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId}`,
          })
        );
      }
    };

    const filterData = (e: any) => {
        if (e.target.value !== "") {
            setSearch(e.target.value);

            const filterTable: any =
                tableData && tableData.length > 0
                    ? tableData.map((item: any) =>
                        item?.pileId
                            ?.toLowerCase()
                            ?.includes(e.target.value?.toLowerCase())
                    )
                    : [];
            setTableData(filterTable);

        }
    };
    useEffect(()=>{
        setDrawerData(steelConsumptionDataProjectwise);
        setDrawerData(steelConsumptionData);
    },[steelConsumptionData, steelConsumptionDataProjectwise])

    useEffect(() => {
        setTableData([]);
        if (projectId !== "") {
            dispatch(
                getSteelConsumptionById({
                    endPoint: `piles/steel-consumption/?projectId=${projectId}`
                })
            );
            
        }
        else {
            dispatch(
                getSteelConsumption({
                    endPoint: `piles/steel-consumption`,
                })
            );
            
        }
    }, [dispatch, projectId])

    useEffect(() => {
        dispatch(
            getAllProjectData({
                endPoint: `project/get-all-projects`,
            })
        );

    }, [dispatch]);

    // useEffect(() => {
    //     if (allProjectData) {
    //         setProjectList(() => allProjectData.map((val: any) => val._id));
    //     }
    // }, [ allProjectData]);

    useEffect(() => {
        if (projectId !== "") {
            dispatch(
                getSteelReconciliationByProject({
                    endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId}`
                })
            );
        }
        else dispatch(
            getSteelReconciliation({
                endPoint: `inventory/get-overall-steel-reconciliation`,
            })
        );

    }, [dispatch, projectId])

    const projectsData: [] =
        allProjectData &&
        allProjectData?.map((item: any) => {
            return item?.projectName;
        });

    useEffect(() => {
        if (Array.isArray(drawerData) && pileId !== "") {
            let pileData = drawerData.filter(
                (item: any) => item.pileId === pileId && item
            );
            setPileList(pileData[0]);
        }
    }, [drawerData, pileId]);

    const displayPileData = () => {
        // setDrawerData(drawerData);
        setDrawerToggle(true);
    }

    const changeReset = () => { };

    useEffect(() => {
        // to convert data in table format so that downloading will be.
        let datafortable: any;
        if (projectId === "") {
            if (steelConsumptionData?.length > 0) {
                datafortable = steelConsumptionData?.filter((item:any)=>item?.pileStatus==="completed"||item.pileStatus==="completed with delay")?.map((val: any) => ({
                    id: val?._id,
                    pileId: val?.pileId,
                    "8 mm": (val?.reinforcement[0]?.type === 8) ? (val?.reinforcement[0]?.count) : "0",
                    "10 mm": (val?.reinforcement[0]?.type !== 10) ? (val?.reinforcement[1]?.type === 10) ? (val?.reinforcement[1]?.count) : "0" : (val?.reinforcement[0]?.count),
                    "12 mm": (val?.reinforcement[0]?.type !== 12) ? (val?.reinforcement[1]?.type !== 12) ? (val?.reinforcement[2]?.type === 12) ? (val?.reinforcement[2]?.count) : "0"
                        : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "16 mm": (val?.reinforcement[0]?.type !== 16) ? (val?.reinforcement[1]?.type !== 16) ? (val?.reinforcement[2]?.type !== 16) ? (val?.reinforcement[3]?.type === 16) ? (val?.reinforcement[3]?.count) : "0"
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "20 mm": (val?.reinforcement[0]?.type !== 20) ? (val?.reinforcement[1]?.type !== 20) ? (val?.reinforcement[2]?.type !== 20) ? (val?.reinforcement[3]?.type !== 20) ? (val?.reinforcement[4]?.type === 20)
                        ? (val?.reinforcement[4]?.count) : "0" : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "25 mm": (val?.reinforcement[0]?.type !== 25) ? (val?.reinforcement[1]?.type !== 25) ? (val?.reinforcement[2]?.type !== 25) ? (val?.reinforcement[3]?.type !== 25) ? (val?.reinforcement[4]?.type !== 25) ?
                        (val?.reinforcement[5]?.type === 25) ? (val?.reinforcement[5]?.count) : "0" : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "32 mm": (val?.reinforcement[0]?.type !== 32) ? (val?.reinforcement[1]?.type !== 32) ? (val?.reinforcement[2]?.type !== 32) ? (val?.reinforcement[3]?.type !== 32) ? (val?.reinforcement[4]?.type !== 32) ?
                        (val?.reinforcement[5]?.type !== 32) ? (val?.reinforcement[6]?.type === 32) ? (val?.reinforcement[6]?.count) : "0" : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "36 mm": (val?.reinforcement[0]?.type !== 36) ? (val?.reinforcement[1]?.type !== 36) ? (val?.reinforcement[2]?.type !== 36) ? (val?.reinforcement[3]?.type !== 36) ? (val?.reinforcement[4]?.type !== 36) ?
                        (val?.reinforcement[5]?.type !== 36) ? (val?.reinforcement[6]?.type !== 36) ? (val?.reinforcement[7]?.type === 36) ? (val?.reinforcement[7]?.count) : "0" : (val?.reinforcement[6]?.count)
                            : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "total": val?.total.toFixed(3)

                }));
                setTableData(datafortable);
            }
        } else if (projectId !== "") {
            if (steelConsumptionDataProjectwise?.length > 0) {
                datafortable = steelConsumptionDataProjectwise?.filter((item:any)=>item?.pileStatus==="completed"||item.pileStatus==="completed with delay")?.map((val: any) => ({
                    id: val?._id,
                    pileId: val?.pileId,
                    "8 mm": (val?.reinforcement[0]?.type === 8) ? (val?.reinforcement[0]?.count) : "0",
                    "10 mm": (val?.reinforcement[0]?.type !== 10) ? (val?.reinforcement[1]?.type === 10) ? (val?.reinforcement[1]?.count) : "0" : (val?.reinforcement[0]?.count),
                    "12 mm": (val?.reinforcement[0]?.type !== 12) ? (val?.reinforcement[1]?.type !== 12) ? (val?.reinforcement[2]?.type === 12) ? (val?.reinforcement[2]?.count) : "0"
                        : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "16 mm": (val?.reinforcement[0]?.type !== 16) ? (val?.reinforcement[1]?.type !== 16) ? (val?.reinforcement[2]?.type !== 16) ? (val?.reinforcement[3]?.type === 16) ? (val?.reinforcement[3]?.count) : "0"
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "20 mm": (val?.reinforcement[0]?.type !== 20) ? (val?.reinforcement[1]?.type !== 20) ? (val?.reinforcement[2]?.type !== 20) ? (val?.reinforcement[3]?.type !== 20) ? (val?.reinforcement[4]?.type === 20)
                        ? (val?.reinforcement[4]?.count) : "0" : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "25 mm": (val?.reinforcement[0]?.type !== 25) ? (val?.reinforcement[1]?.type !== 25) ? (val?.reinforcement[2]?.type !== 25) ? (val?.reinforcement[3]?.type !== 25) ? (val?.reinforcement[4]?.type !== 25) ?
                        (val?.reinforcement[5]?.type === 25) ? (val?.reinforcement[5]?.count) : "0" : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "32 mm": (val?.reinforcement[0]?.type !== 32) ? (val?.reinforcement[1]?.type !== 32) ? (val?.reinforcement[2]?.type !== 32) ? (val?.reinforcement[3]?.type !== 32) ? (val?.reinforcement[4]?.type !== 32) ?
                        (val?.reinforcement[5]?.type !== 32) ? (val?.reinforcement[6]?.type === 32) ? (val?.reinforcement[6]?.count) : "0" : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "36 mm": (val?.reinforcement[0]?.type !== 36) ? (val?.reinforcement[1]?.type !== 36) ? (val?.reinforcement[2]?.type !== 36) ? (val?.reinforcement[3]?.type !== 36) ? (val?.reinforcement[4]?.type !== 36) ?
                        (val?.reinforcement[5]?.type !== 36) ? (val?.reinforcement[6]?.type !== 36) ? (val?.reinforcement[7]?.type === 36) ? (val?.reinforcement[7]?.count) : "0" : (val?.reinforcement[6]?.count)
                            : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "total": val?.total.toFixed(3)

                }));
                setTableData(datafortable);
            }
        }

    }, [steelConsumptionData, steelConsumptionDataProjectwise, projectId]);

    const fields = [
        {
            header: "Pile Id",
            search: true,
            value: "pileId",
            action: function (obj: any) {
                return (
                    <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                            displayPileData();
                            setPileId(obj.pileId);
                        }}
                    >
                        {obj.pileId}
                    </Text>
                );
            },

        },
        { header: "8 mm", value: "8 mm", search: true },
        { header: "10 mm", value: "10 mm", search: true },
        { header: "12 mm", value: "12 mm", search: true },
        { header: "16 mm", value: "16 mm", search: true },
        { header: "20 mm", value: "20 mm", search: true },
        { header: "25 mm", value: "25 mm", search: true },
        { header: "32 mm", value: "32 mm", search: true },
        { header: "36 mm", value: "36 mm", search: true },
        { header: "Total Consumption", value: "total", search: true },
    ]    
    useEffect(() => {
      if (steelReconciliationData.length > 0) {
        const steelData: any = steelDias.map((steelDia: any, index: number) => {
          const receivedQty =
            steelReconciliationData.length > 0 &&
            steelReconciliationData[index].length > 0
              ? steelReconciliationData[index][0].received
              : 0;
          const consumedQty = tableData
            .map((item: any) => {
            //   console.log(item[steelDia]);
              return item[steelDia];
            })
            .reduce((preVal: any, currVal: any) => {
            //   console.log(preVal, currVal);
              return preVal + parseInt(currVal);
            }, 0);
          const QtyInStock =
            Number(receivedQty) - Number(consumedQty) > 0
              ? Number(receivedQty) - Number(consumedQty)
              : 0;

          return {
            title: steelDia,
            received: receivedQty,
            consumed: consumedQty,
            inStock: QtyInStock,
          };
        });
        setCardData(steelData);
      }
      if (steelReconciliationDataById.length > 0) {
        const steelData: any = steelDias.map((steelDia: any, index: number) => {
          const consumedQty = tableData
            .map((item: any) => {
              return item[steelDia];
            })
            .reduce((preVal: any, currVal: any) => {
              return preVal + parseInt(currVal);
            }, 0);
          const receivedQty =
            steelReconciliationDataById.length > 0 &&
            steelReconciliationDataById[index].length > 0
              ? steelReconciliationDataById[index][0].received
              : 0;
          const QtyInStock =
            Number(receivedQty) - Number(consumedQty) > 0
              ? Number(receivedQty) - Number(consumedQty)
              : 0;
        //   console.log(steelReconciliationDataById[index][0]);
          return {
            title: steelDia,
            received: receivedQty,
            consumed: consumedQty,
            inStock: QtyInStock,
          };
        });
        setCardData2(steelData);
      }
    }, [steelReconciliationData, steelReconciliationDataById, tableData]);
    // console.log(cardData);
    // console.log(cardData2);
    const dataToDownload = tableData;
    return (
        <Grid container className="mt0 pt1">
            <Grid container className="bg--white box--shadow mt0 plr-1">
                <Grid className="standared_width">
                    <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1 pl0">
                        <span className="fw500">Steel Reconciliation Report</span>
                    </Text>
                </Grid>
                <Grid xs={12} className="mt1 mb1">
                    <Grid className="radio_box">
                        <Radio
                            checked={
                                isOverallTable
                            }
                            onChange={(e) => {
                                setIsOverallTable(true);
                                setProjectId('');
                                setProjectName('');
                            }}
                            value="mandatory"
                            name="isMandatory"
                            inputProps={{ "aria-label": "Mandatory" }}
                            color="primary"
                        />
                        <label>Overall</label>
                        <Radio
                            checked={
                                !isOverallTable
                            }
                            onChange={(e) => {
                                setIsOverallTable(false);
                                setProjectId('');
                            }}

                            value="optional"
                            name="isMandatory"
                            inputProps={{ "aria-label": "Optional" }}
                            color="primary"
                        />
                        <label>Project-Wise</label>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    {!isOverallTable && <Grid xs={3}>
                        <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                            <span className="fw500">Select Project</span>
                        </Text>
                        <SelectBox
                            data={projectsData ? projectsData : DATA_NOT_FOUND}
                            placeHolder="Select Project"
                            defaultVal={projectName}
                            borderColor={"primary"}
                            changeReset={changeReset}
                            onChange={(e: any) => {
                                setProjectName(e.target.value);
                                const index = projectsData
                                    ?.map((item: any) => item)
                                    .indexOf(e.target.value);
                                setProjectId(
                                    allProjectData && allProjectData[index]?._id
                                );
                            }}
                        />
                    </Grid>}
                    <Grid item
                        className=""
                        direction="row"
                        alignItems="center">
                        <div className="filter_box_ml mt2">
                            <FilterComponent
                                handleFilterDate={handleFilterDate}
                                setValue={setValue}
                                value={value}
                                resetAll={resetToAll}
                            />
                        </div>
                    </Grid>

                    <Grid item >
                        <Button
                            type="button"
                            size="medium"
                            isRounded={true}
                            category="primary"
                            onClick={() => {

                            }}
                            className="submit_button f14 mt2"
                        >
                            <SVG type={"searchIcon"} />
                            Search
                        </Button>
                    </Grid>
                </Grid>

                {!isOverallTable ? (projectName !== "" ? (
                    <>
                        <Grid xs={12}>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1">
                                <span className="fw500">Steel Statistics</span>
                            </Text>
                        </Grid>

                        <Slider
                            data={cardData2}
                            Component={SteelCard}
                        />

                        <List
                            listData={tableData}
                            fields={fields}
                            title={"Steel Consumption Details"}
                            dataToDownload={dataToDownload}
                            searchValue={search}
                            setSearchValue={filterData}
                            noBox
                        /> </>) : (

                    <SelectOptionMsg text={`Select project to view Project information`} />)) : (<>
                        <Grid xs={12}>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1">
                                <span className="fw500">Steel Statistics</span>
                            </Text>
                        </Grid>

                        <Slider
                            data={cardData}
                            Component={SteelCard}
                        />

                        <List
                            listData={tableData}
                            fields={fields}
                            title={"Steel Consumption Details"}
                            dataToDownload={dataToDownload}
                            noBox
                        /> </>)}

            </Grid>
            <Grid className="mt0 bar">
                <SteelReconciliationBar />
            </Grid>

            {(
                <Drawer
                    anchor={"right"}
                    open={drawerToggle}
                    onClose={() => setDrawerToggle(false)}
                >
                    <PileDrawer
                        drawerData={pileList}
                        toggleDrawer={setDrawerToggle}
                    />
                </Drawer>
            )}
        </Grid>
    )
}

export default SteelReconciliationReport;